import { PostEditorErrorKeys } from '../../../../models/validator-props';
import { PostEditorErrors, PostEditorPostError, PostEditorPostErrors } from '../../../../models/post-editor';
import { isArray } from 'lodash';
import { ErrorMessageSeverity } from '../../../../constants/form';

const keyReducer = (
  keyError: PostEditorPostErrors | undefined,
  severity: ErrorMessageSeverity,
  profileId: string | null | undefined,
  variationId: number | null | undefined,
  selectedProfileId: string | null
): boolean => {
  if (!keyError) return false;
  if (isArray(keyError)) {
    const err = keyError as PostEditorPostError[];
    return err.reduce((prev, curr) => {
      if (prev) return prev;
      return (
        curr.severity === severity &&
        (profileId !== undefined ? curr.profileId === profileId : true) &&
        (variationId !== undefined ? curr.variationId === variationId : true) &&
        (selectedProfileId ? curr.selectedSocialProfiles.some(p => p.profileId === selectedProfileId) : true)
      );
    }, false);
  } else {
    const err = keyError as PostEditorPostError;
    return (
      err.severity === severity &&
      (profileId !== undefined ? err.profileId === profileId : true) &&
      (variationId !== undefined ? err.variationId === variationId : true) &&
      (selectedProfileId ? err.selectedSocialProfiles.some(p => p.profileId === selectedProfileId) : true)
    );
  }
};
// this validator helper will return boolean value for the given validation rule (key param) it the requested
// severity under postIndex exists
export const hasSeverity = (
  error: PostEditorErrors,
  severity: ErrorMessageSeverity,
  profileId: string | null | undefined,
  variationId: number | null | undefined,
  key: PostEditorErrorKeys | PostEditorErrorKeys[] | 'all',
  selectedProfileId?: string
): boolean => {
  if (isArray(key)) {
    // return key.reduce((prevKey, currKey) => {
    //   if (prevKey) return prevKey;
    //   const result = keyReducer(error[currKey], severity, profileId, variationId);
    //   return result;
    // }, false);
    return key.reduce(
      (prevKey, currKey) =>
        prevKey
          ? prevKey
          : keyReducer(error[currKey], severity, profileId, variationId, selectedProfileId ? selectedProfileId : null),
      false
    );
  } else if (key === 'all') {
    const keys = Object.keys(error) as PostEditorErrorKeys[];

    return keys.reduce(
      (prevKey, currKey) =>
        prevKey
          ? prevKey
          : keyReducer(error[currKey], severity, profileId, variationId, selectedProfileId ? selectedProfileId : null),
      false
    );
  } else {
    return keyReducer(error[key], severity, profileId, variationId, selectedProfileId ? selectedProfileId : null);
  }
};
